<template>
    <main class="SectionArtists-MAIN DISPLAY">

        <HeaderBand/>

        <section class="SectionArtists-monitor">
            <div v-if="viewMode == 'list'" class="monitor-list">
                <h2>Fichas</h2>
                <hr/>
                <div>
                    <p>INDEX: A-Z</p>
                    <p>FILTRO: TODO</p>
                </div>
            </div>
            <div v-if="viewMode == 'carousel'" class="monitor-carousel">
                <h2 @click="viewArtworkCard(selectedArtworkId)">{{ selectedArtworkTitle }}</h2>
                <p @click="viewArtistProfile(selectedArtistId)">{{ selectedArtistName }}</p>
                <p>{{ selectedArtworkTechnique }}</p>
            </div>
            <div v-if="viewMode == 'tiles'" class="monitor-tiles">
                <h2 @click="viewArtistProfile(selectedArtistId)">{{ selectedArtistName }}</h2>
                <hr/>
                <h3 @click="viewArtworkCard(selectedArtworkId)">{{ selectedArtworkTitle }}</h3>
            </div>
        </section>

        <!--views-->
        <section class="ArtistsView-list hide-scrollbar" v-if="viewMode == 'list'">
            <div v-for="(item, index) in allArtists" :key="index" @click="viewArtistProfile(item.id)">
                <div>
                    <div>
                        <h2>ID: AP{{ item.id }}</h2>
                        <h4>{{ item.apellido }}, {{ item.nombre }}</h4>
                    </div>
                    <img :src="getBarcodeSrc(item.id)" alt="barcode" />
                </div>
                <div>
                    <p><span>Edad:</span> <span>28</span></p>
                    <p><span>Origen:</span> <span>Estado de México.</span></p>
                    <p><span>Disciplina:</span> <span>Pintura, Fotografía.</span></p>
                </div>
                <img v-if="item.image_on_list" :src="`${this.$ENDPOINT}/assets/list/${item.image_on_list}`"/>
            </div>
        </section>

        <section class="ArtistsView-carousel hide-scrollbar" v-if="viewMode == 'carousel'" ref="carouselView" @scroll="onScrollCarousel">
            <div class="carousel-container hide-scrollbar" v-for="(item, index) in artworksByArtists" :key="index" @scroll="onScrollCarousel" @scrollend="endScrollCarousel">
                <img v-for="(artwork, subindex) in item" :key="subindex" :src="`${this.$ENDPOINT}/assets/thumbnails_artworks/${artwork.file}`" :ref="el => carouselRefs.push({el, artwork})" @click="viewArtworkCard(artwork.id)"/>
            </div>
        </section>

        <section class="ArtistsView-tiles hide-scrollbar" v-if="viewMode == 'tiles'">
            <div class="tiles-container hide-scrollbar">
                <RandomTiles :artworks="tilesAllArtworks"/>
            </div>
        </section>

    </main>
</template>

<script>
import HeaderBand from '@/components/HeaderBand.vue';
import RandomTiles from '@/components/RandomTiles.vue';
import bwipjs from '@bwip-js/browser';

export default {
    name: 'SectionArtists',
    components: {
        HeaderBand,
        RandomTiles,
    },
    inject: ['vibration'],
    data() {
        return {
            viewMode: '', // 'list' | 'carousel' | 'tiles'
            carouselRefs: [],
            selectedArtistName: 'Cargando...',
            selectedArtistId: 0,
            selectedArtworkTitle: 'Cargando...',
            selectedArtworkId: 0,
            selectedArtworkTechnique: '',
            artworksByArtists: {},
            tilesAllArtworks: [],
            allArtists: [],
            barcodeCache: {},
        }
    },
    props: {
        display: String
    },
    methods: {
        async loadData() {
            const response = await fetch(`${this.$ENDPOINT}/api/get_search_data.php`)
            const result = await response.json()

            for (const [, val] of Object.entries(result.obras)) {
                if (Array.isArray(this.artworksByArtists[val.artist_nombre])) {
                    this.artworksByArtists[val.artist_nombre].push(val);
                } else {
                    this.artworksByArtists[val.artist_nombre] = [val];
                }
                this.tilesAllArtworks.push(val);
            }
            this.allArtists = result.artistas;
        },

        applyDisplayFromRoute() {
            const allowed = new Set(['list', 'carousel', 'tiles'])
            const d = (this.display || '').toLowerCase()

            const finalMode = allowed.has(d) ? d : 'list'
            this.viewMode = finalMode;

            if (!allowed.has(d)) {
                this.$router.replace({ name: 'artists', params: { display: 'list' } })
            }

            if(this.viewMode == 'carousel') return this.onScrollCarousel();
            if(this.viewMode == 'tiles') {
                this.selectedArtistName = "Obras";
                this.selectedArtworkTitle = "Vista de cuadrícula";
                return;
            }
        },

        getBarcodeSrc(value){
            const text = `AP${value}`;          // lo que quieres codificar
            const key = `code128:${text}`;
            if (this.barcodeCache[key]) return this.barcodeCache[key];

            try {
                const canvas = document.createElement('canvas');
                bwipjs.toCanvas(canvas, {
                    bcid: 'code128',     // tipo: code128, ean13, upca, etc.
                    text,                // contenido
                    scale: 3,            // tamaño
                    height: 10,          // altura de barras
                    includetext: false,  // si quieres mostrar el texto debajo
                    textxalign: 'center',
                });
                const dataUrl = canvas.toDataURL('image/png');
                this.barcodeCache[key] = dataUrl;
                return dataUrl;
            } catch (e) {
                console.warn('Barcode error:', e);
                return '';
            }
        },

        onScrollCarousel(){           
            this.$nextTick(() => {
                for(let i of this.carouselRefs){
                    const element = i.el;
                    const top = element?.getBoundingClientRect().top;
                    const bottom = top + element?.offsetHeight;
                    const left = element?.getBoundingClientRect().left;
                    const right = left + element?.offsetWidth;
                    const centerVertical = window.innerHeight/2;
                    const centerHorizontal = window.innerWidth/2;
                    if((top < centerVertical && centerVertical < bottom) && (left < centerHorizontal && centerHorizontal < right)){
                        if(this.selectedArtworkId != i.artwork.id) this.vibration(25);
                        this.selectedArtistName = i.artwork.artist_nombre + " " + i.artwork.artist_apellido;
                        this.selectedArtistId = i.artwork.artist_id;
                        this.selectedArtworkTitle = i.artwork.titulo;
                        this.selectedArtworkId = i.artwork.id;
                        this.selectedArtworkTechnique = i.artwork.technique;
                        break;
                    }
                }
            });
        },

        endScrollCarousel(){
            for(let i of this.carouselRefs){
                    const element = i.el;
                    const top = element?.getBoundingClientRect().top;
                    const bottom = top + element?.offsetHeight;
                    const left = element?.getBoundingClientRect().left;
                    const right = left + element?.offsetWidth;
                    const centerVertical = window.innerHeight/2;
                    const centerHorizontal = window.innerWidth/2;
                    if((top < centerVertical && centerVertical < bottom) && (left < centerHorizontal && centerHorizontal < right)){
                        const parent = element.parentNode;

                        // 1) posición del elemento dentro del padre
                        const parentRect = parent.getBoundingClientRect();
                        const elemRect = element.getBoundingClientRect();
                        // diferencias relativas al padre
                        const offsetTop = elemRect.top - parentRect.top + parent.scrollTop;
                        const offsetLeft = elemRect.left - parentRect.left + parent.scrollLeft;
                        // 2) centramos dentro del padre
                        const targetTop =
                            offsetTop - (parent.clientHeight / 2) + (element.offsetHeight / 2);
                        const targetLeft =
                            offsetLeft - (parent.clientWidth / 2) + (element.offsetWidth / 2);

                        parent.scrollTo({
                            top: targetTop,
                            left: targetLeft,
                            behavior: 'smooth'
                        });
                        this.vibration(25);

                        break;
                    }
                }
        },

        viewArtworkCard(id){
            this.$router.push({ name: 'artworkcard', params: { id: String(id) } });
        },

        viewArtistProfile(id){
            this.$router.push({ name: 'artistfull', params: { id: String(id) } });
        }

    },
    async mounted() {
        await this.loadData();
        this.applyDisplayFromRoute();
    },
    watch: {
        display() {
            this.applyDisplayFromRoute()
        }
    }
}
</script>

<style scoped lang="stylus">
.SectionArtists-MAIN 
    background-color: black
    position: relative
    max-height: 100vh

    >section:not(.SectionArtists-monitor):not(.ArtistsView-list)
        mask-image: linear-gradient(to bottom, transparent 0%, white 25%, white 86%, transparent 100%)
        -webkit-mask-image: linear-gradient(to bottom, transparent 0%, white 25%, white 86%, transparent 100%)
        
/* monitor */
.SectionArtists-monitor 
    display: flex
    flex-direction: column
    height: fit-content
    background-color: white
    border-radius: 5vw
    margin: 3vw
    padding: 2vw 3vw
    font-family: "Archivo ExtraCondensed", sans-serif
    text-transform: uppercase
    z-index: 2

/* monitor modes */

.monitor-list
.monitor-carousel
.monitor-tiles
    margin: 3vw 0

.monitor-list 
    height: 14vw
    min-height: fit-content
    display: flex
    flex-direction: column
    justify-content: space-between

    h2
        font-size: 8vw
        margin: -1vw 0
        margin-top: 1vw
        font-weight: 500

    hr
        width: 100%

    >div
        display: flex
        align-items: center
        justify-content: space-between
        margin: 0
        margin-top: 1vw
        margin-bottom: -1vw

        p
            margin: 0
            color: #707070
            font-size: 3vw
            font-weight: 100
            font-family: "DM Mono", monospace

.monitor-carousel

    h2
        margin: 0
        font-weight: 500

    >p
        margin: 0
        margin-top: 5px

        &:nth-child(3)
            color: #707070
            font-family: "DM Mono", monospace
            font-size: 3vw

.monitor-tiles
    height: 14vw
    min-height: fit-content

    h2
    h3
        margin: 0

    h2
        font-weight: 500

    h3
        font-weight: 200

    hr
        border-top: 1px solid black

/* view: list */
.ArtistsView-list
    width: 100%
    height: calc(100% + 14vw)
    margin-top: -14vw
    padding-top: 14vw
    padding-bottom: calc(6vw + 47px)
    overflow: auto

    >div
        position: relative
        padding: 20px 15px
        padding-bottom: 15px
        margin: 0 3vw
        border-radius: 2vw
        font-family: "DM Mono", monospace
        background-color: #DCDCDC
        cursor: pointer
        display: flex
        flex-direction: column
        justify-content: space-between
        border-bottom: 1px dashed #6E6E6E
        overflow: hidden

        &:last-child
            border-bottom: none

        >div:nth-child(1)
            display: flex
            justify-content: space-between

            h2
            h4
                margin-top: 0
                margin-bottom: 4vw
                text-transform: uppercase
            
            h2
                font-family: "Archivo Condensed", sans-serif
                font-weight: 500
                font-size: 7vw

            h4
                font-size: 3.5vw

            >img
                width: 23vw
                height: auto
                align-self: flex-start
                flex: 0 0 auto
                opacity: 0.2
                margin-top: -5px

        >div:nth-child(2)
            margin-top: 20px

            >p
                margin: 0
                display: grid
                grid-template-columns: 33% auto
                text-transform: uppercase
                opacity: 0.5
                font-size: 2.8vw
                line-height: 3vw

        >img
            position: absolute
            height: 100%
            top: 0
            right: 0
            mix-blend-mode: multiply
            opacity: 0.9

/* view: carousel */
.ArtistsView-carousel
    //height: calc(100dvh - 38vw)
    height: 100dvh
    width: 100%
    position: absolute
    top: 0
    //padding-top: 38vw
    overflow-x: auto
    overflow-y: visible !important
    display: flex
    flex-direction: column
    align-items: center
    border-radius: 10px

.carousel-container
    display: flex
    align-items: center
    width: 100%
    overflow: auto
    //height: calc(100dvh - 14vw - 20dvh - 47px)
    //min-height: calc(100dvh - 14vw - 20dvh - 47px)
    height: 100dvh
    min-height: 100dvh

    img
        width: 100vw !important
        min-width: 100vw !important
        //height: calc(100dvh - 14vw - 20dvh - 47px)
        height: 100dvh
        object-fit: cover
        //margin: 0 2vw

/* view: tiles */
.ArtistsView-tiles
    height: 100dvh
    width: 100%
    position: absolute
    top: 0

.tiles-container
    border-radius: 1vw
    height: 100%
    padding-top: 38vw
    overflow: auto
    display: flex
    flex-direction: column
</style>